module.exports = __webpack_public_path__ + "static/img/logo.77c8f82.png";